import { inject, injectable } from "inversify";
import { ClientPortalGlobalSearchResultModel, ICPLClientPortalGlobalSearchClient } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IClientPortalGlobalSearchService {
  globalSearch(searchTerm: string): Promise<ClientPortalGlobalSearchResultModel[]>;
}

@injectable()
export class ClientPortalGlobalSearchService implements IClientPortalGlobalSearchService {
  @inject(SERVICE_TYPES.CPLClientPortalGlobalSearchClient)
  cplClientPortalGlobalSearchClient!: ICPLClientPortalGlobalSearchClient;

  async globalSearch(searchTerm: string): Promise<ClientPortalGlobalSearchResultModel[]> {
    return this.cplClientPortalGlobalSearchClient.globalSearch(searchTerm);
  }
}
